import ViewFormulasComponent from "../components/formulas/ViewFormulas";

export default function ViewFormulasPage() {
  return <ViewFormulasComponent />;
}
